<div class="fcc-label">
    <xfinity-broadband-facts
        [geoCode]="geoCode"
        [state]="state"
        [mobileSegmentLevel]="labelDetails?.segmentLevel"
        [tierIds]="labelDetails?.planId"
        [servicePlanType]="labelDetails?.planType"
        [lineOfBusiness]="labelDetails?.lineOfBusiness">
    </xfinity-broadband-facts>
</div>
